import { ObservableArray, View } from "binder"
import { InvoicesListViewModel, item } from "./invoicesList-viewModel"

export class InvoicesListView extends View<InvoicesListViewModel>{
    GetViewUniqueId(): string {
        return "V-785B689D-C108-40DD-9F15-048B2513BA53"
    }
    loadHtml(): string {
        let element = require('./invoicesList.html').default;
        let style = require('./invoicesList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;

}
